<template>
<div>

<modal v-model="modalData" :title="currentCash ? 'Datos de Caja Asignada' : 'Datos del negocio'" dir="right" modalClass="right md h100">
    <div class="pa20" v-if="modalData">
        <template v-if="!currentCash">
            <span>
                <div class="mb15">
                    <div class="bold">Usuario Mercado Pago</div>
                    <div>{{modalData.user.nickname}} - {{modalData.user.id}}</div>
                </div>
                <div class="mb15">
                    <div class="bold">Sucursal</div>
                    <div>{{modalData.store.name}} - {{modalData.store.id}}</div>
                </div>

                <div class="mb15">
                    <div class="bold">Cajas</div>
                    <input-select class="flex-fill mt5"
                    v-model="modalData.cashSelected"
                    :items="cashItems">
                    </input-select>
                </div>
            </span>
        </template>
        <template v-else>
            <span>
                <div class="mb15">
                    <div class="bold">Caja</div>
                    <div>{{currentCash.pos_name}}</div>
                </div>

                <div class="mb15">
                    <div class="bold">Terminal</div>
                    <div>{{currentCash.terminal_id}}</div>
                </div>
            </span>
        </template>
        <div class="mt10 mb10 flex align-center">
            <div class="f18 flex-fill">Log</div>
            <button class="secondary" @click="showLog = !showLog">{{ showLog ? 'Ocultar' : 'Mostrar' }}</button>
        </div>

        <textarea v-if="showLog" v-model="log" readonly style="font-family: monospace !important; font-size: 10px !important; width: 100%; background: transparent; color: inherit; border: none" rows="40" wrap="off"></textarea>

    </div>
    <button slot="actions" class="primary error-color" v-if="currentCash" @click="DeleteCash()">Eliminar Caja</button>
    <button slot="actions" class="primary purple" v-else @click="AsingCash(modalData.cashSelected)">Asignar Caja</button>
</modal>
<modal v-model="modalPassword">
    <div class="pa20" v-if="modalPassword">
        <input-field
        label="Contraseña"
        type="password"
        v-model="modalPassword.password">
        </input-field>
    </div>
    <button slot="actions" class="primary purple" @click="Open(modalPassword.password)">Ingresar</button>
</modal>
</div>
</template>

<script>

export default {
    props : {
        activeSettingOption : {
            type: Boolean,
            default: false
        },
        accessCode: {
            type: String,
            default: '',
        }
    },
    data() {
        return {
            // -----------------
            modalData : null,
            currentCash : null,
            currentMercadoPagoOrder : null,
            modalPassword : null,
            showLog: false,
            log : '',
        }
    },
    mounted() {
        this.log = localStorage.mercadopagoLog ? localStorage.mercadopagoLog : '';
        this.currentCash = localStorage.cash_mercadopago && this.activeSettingOption ? JSON.parse(localStorage.cash_mercadopago) : null;
        if(this.currentCash) this.$emit('OnChangeCash', this.currentCash);
    },
    methods: {
        Open(password) {
            if(!password) return this.modalPassword = {password: ''};
            if(password != this.accessCode) return this.Info('Código incorrecto');

            if(!this.currentCash) this.GetDataMercadoPagoPOS();
            this.modalData = this.currentCash;
            this.modalPassword = null;
        },
        GetDataMercadoPagoPOS(){
        this.Log("> GetDataMercadoPago");
            this.Loading();
            axios.get(`/settings/${this.Local.id}/mercadopago/pos`).then((res) => {
                this.Log("> GetDataMercadoPago ok: "+ JSON.stringify(res.data));
                let data = res.data;
                let result = data.pos.map(pos => {
                    const terminal = data.terminal.find(
                        terminal => terminal.pos_id === pos.id
                    );

                    return {
                        ...pos,
                        terminal: terminal || null
                    };
                });
                this.modalData = {
                    user : {
                        id : data.user_id,
                        nickname : data.user_nickname
                    },
                    store : {
                        id : data.store.id,
                        name : data.store.name
                    },
                    pos : result
                };
                this.Response(res);
            })
            .catch(err => {
                this.Log("> GetDataMercadoPago error: "+ JSON.stringify(err));
                this.Response(err);
            });
        },
        AsingCash(cash) {
            this.Log("> AsignCash");
            if(!cash.terminal_id){ 
                this.Log("> AsignCash error: La caja seleccionada, no tiene terminal asignado");
                return this.Info("La caja seleccionada, no tiene terminal asignado");
            }
            localStorage.setItem('cash_mercadopago', JSON.stringify(cash));
            this.currentCash = cash;
            this.$emit('OnChangeCash', cash);
            this.modalData = null;
            this.Log("> AsignCash ok: "+ JSON.stringify(cash));
            this.Info("Caja asignada");
        },
        DeleteCash() {
            this.Log("> DeleteCash");
            if(!this.currentCash) return;
            localStorage.removeItem('cash_mercadopago');
            this.$emit('OnChangeCash');
            this.currentCash = null;
            this.modalData = null;
            this.Log("> DeleteCash ok: Caja eliminada");
            this.Info("Caja eliminada");
        },
        SendToPoint(order){
            this.Log("> SendPoint");
            if(!order) return;
            let terminal = localStorage.cash_mercadopago ? JSON.parse(localStorage.cash_mercadopago) : null;
            if(!terminal) return this.Info("No existe caja de Mercado Pago asignada");
            order = {...order, ...terminal};
            
            this.Loading();
            axios.post(`/transaction/${this.Local.id}/point`, order).then((res) => {
                this.Log("> SendPoint ok: "+ JSON.stringify(res.data));
                this.$emit('OnResponseToPoint', order);
                this.currentMercadoPagoOrder = res.data;
                this.Response(res);
            })
            .catch(err => {
                this.Log("> SendPoint error: "+JSON.stringify(err));
                this.Response(err);
            });
        },
        Log(msg)
        {
            const now = new Date();

            // Extract individual parts of the date and time
            const hours = String(now.getHours()).padStart(2, '0');
            const minutes = String(now.getMinutes()).padStart(2, '0');
            const seconds = String(now.getSeconds()).padStart(2, '0');
            const day = String(now.getDate()).padStart(2, '0');
            const month = String(now.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
            const year = now.getFullYear();

            // Combine into the desired format
            let date = `${hours}:${minutes}:${seconds} ${day}/${month}/${year}`;

            let lineMsg = `${date} - ${msg}`;

            let lines = this.log.split(/\n/g);
            lines.unshift(lineMsg);
            if(lines.length > 1000) lines.pop();
            this.log = lines.join('\n');
            localStorage.mercadopagoLog = this.log;
            console.log(lineMsg);
        },
    },
    computed : {
        cashItems () {
            if(!this.modalData || !this.modalData.pos) return [];
            return this.modalData.pos.map(pos => ({
                text: `${pos.name} - ${pos.terminal ? pos.terminal.id : 'Sin terminal'}`,
                value: {pos_id : pos.id, pos_name: pos.name, terminal_id :pos.terminal ? pos.terminal.id : null}
            }));
        }
    }
}
</script>